const routes = [
  // {
  //   path: '/home',
  //   name: 'home',
  //   component: () => import('@/views/HomeView.vue')
  // },
  // 育人后管-学生信息填写页
  {
    path: '/yuren/inputstudentinfo',
    name: 'inputStudentInfo',
    component: () => import('@/views/yurenManagement/pc/inputStudentInfo/InputStudentInfo.vue'),
  },
  // {
  //   path: '/fission',
  //   name: 'fission',
  //   component: () => import('@/views/fission/Fission.pc.vue'),
  //   meta: {
  //     title: 'WPS 365教育版 | 年度锦鲤活动',
  //   },
  // },
  {
    path: 'learningHub',
    name: 'learningHub',
    component: () => import('@/views/learningHub/pc/index.pc.vue'),
    meta: {
      title: 'WPS 365 学习园地',
    },
  },
  {
    path: 'learningHub/more',
    name: 'learningHubMore',
    component: () => import('@/views/learningHub/pc/index.more.vue'),
    meta: {
      title: 'WPS 365 学习园地',
    },
  },
  {
    path: '/summerBenefits',
    name: 'summerBenefits',
    component: () => import('@/views/summerBenefits/SummerBenefits.pc.vue'),
    meta: {
      title: 'WPS夏日送福利活动',
    },
  },
  {
    path: '/schoolOpensBenefits',
    name: 'schoolOpensBenefits',
    component: () => import('@/views/schoolOpensBenefits/index.pc.vue'),
    meta: {
      title: '乐享特权卡，积分赢豪礼',
    },
  },
  {
    path: '/ssoLogin',
    name: 'ssoLogin',
    component: () => import('@/views/ssoLogin/pc/index.pc.vue'),
    meta: {
      title: '乐享特权卡，积分赢豪礼',
    },
  },
  {
    path: '/fission',
    name: 'fission',
    component: () => import('@/views/fissionConfigurable/Fission.pc.vue'),
    meta: {
      title: 'WPS 365教育版 | 锦鲤活动',
    },
  },
  // 登录后引导导入文档和关联权益
  {
    path: '/relatedAccount',
    name: 'relatedAccount',
    component: () => import('@/views/relatedAccount/RelatedAccount.pc.vue'),
    meta: {
      title: '',
    },
  },
  // 题库C转B
  {
    path: '/question-privilege',
    name: 'questionPrivilege',
    component: () => import('@/views/questionPrivilege/QuestionPrivilege.pc.vue'),
    meta: {
      title: 'WPS 计算机备考福利大放送！',
    },
  },
  // 春芽活动
  {
    path: '/greenShoots',
    name: 'greenShoots',
    component: () => import('@/views/greenShoots/GreenShoots.pc.vue'),
    meta: {
      title: '开学新装备，WPS权益免费用',
    },
  },
  // 春芽活动
  {
    path: '/greenShootsV2',
    name: 'greenShootsV2',
    component: () => import('@/views/greenShootsV2/GreenShoots.pc.vue'),
    meta: {
      title: '春芽再起航，成长进阶2.0',
    },
  },
  // 教育 Web 中间跳转页
  {
    path: '/eduWebRedirect',
    name: 'eduWebRedirect',
    component: () => import('@/views/eduWebRedirect/EduWebRedirect.pc.vue'),
    meta: {
      title: '',
    },
  },
]

export default routes
